<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <q-btn
      v-if="value && value.startsWith('btnscript://')"
      :icon="getIcon()"
      @click="execScript($event)"
      color="primary"
      :label="getIcon() ? '' : formProperty.title"
      unelevated
      :disable="readOnly || formProperty.readonly"
      style="height:40px"
      :class="'fld' + formProperty.nativename + ' ' + formProperty.cssClass"/>
  </div>
</template>
<script>

import {StaticData} from "src/classes/StaticData";
import {fldComponentsMixin} from './mixins/fldComponent'

export default {
  mixins: [fldComponentsMixin],
  props: [
    'formProperty',
    'readOnly',
    'volatile'
  ],
  components: {},
  data() {
    return {
      value: null,
      parentElement: null,
    }
  },

  methods: {
    getIcon() {
      let result = undefined
      if (this.value && this.value.indexOf("ico") !== -1) {
        let icoPos = this.value.indexOf("ico") + 4
        if (icoPos !== -1) {
          result = this.value.substr(icoPos)
        }
      }
      return result
    },

    execScript(event) {
      setTimeout(() => {
        if (this.value) {
          const triggerElement = "fld" + this.formProperty.nativename
          let src = this.value.replace("btnscript://", "").replace("$triggerElement", "'" + triggerElement + "'").replace("$subtypeCount", this.formProperty.subtypeCount)
          src = src.split("?")
          if (src.length > 1) {
            src = src[0]
          }
          let newScriptElementUsingSource = document.createElement('script')
          newScriptElementUsingSource.setAttribute('type', 'text/javascript')
          newScriptElementUsingSource.appendChild(document.createTextNode(src))
          this.parentElement.appendChild(newScriptElementUsingSource)
        }
      }, 100)
    },

    appendScript() {
      if (this.value && !this.value.startsWith("btnscript://")) {
        setTimeout(() => {
          if (this.value) {
            let src = this.value.replace("script://", "")
            let newScriptElementUsingSource = document.createElement('script')
            newScriptElementUsingSource.setAttribute('type', 'text/javascript')
            newScriptElementUsingSource.appendChild(document.createTextNode(src))
            this.parentElement.appendChild(newScriptElementUsingSource)
          }
        }, 100)
      }
    },

    removeChilds() {
      while (this.parentElement.firstChild) {
        this.parentElement.removeChild(this.parentElement.firstChild);
      }
    },

    onChange(value) {
    },

    onRefreshComp(data) {
      if (this.formProperty.nativename === data.nativename) {

        if (data.isEventFromParameter && !this.formProperty.isParameter) return

        if (this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.value = data.value
          this.appendScript()
        } else {
          this.removeChilds()
        }
      }
    },

    getValue() {
      let result = null

      if (this.formProperty.defaultValue && this.formProperty.defaultValue.startsWith("btnscript://")) {
        result = this.formProperty.defaultValue

      } else if (this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
        result = this.formProperty.value ? this.formProperty.value : this.formProperty.propertyInstanceValue
      }
      return result
    }
  },

  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
  },

  mounted: function () {
    this.eventBus.on('onRefreshComp', this.onRefreshComp)

    let sParent = "cont_" + this.formProperty.nativename
    this.parentElement = document.getElementById(sParent)
    this.value = this.getValue()

    // logger.info("Mount fldScript:", this.formProperty.title, this.value)

    this.appendScript()
  }
}
</script>

